
import formatDate from '../../helpers/dateFormat';
export const filterOpenModsReportData = (obj: any, reportType: string) => {
  if (reportType === 'OpenMode') {
    const filterColumnNames = ['modifications_key', 'property_number', 'property_name', 'due_date', 'dsi_point_person', 'contact_name', 'description', 'content', 'approval', 'graphics', 'transferred', 'invoiced', 'contact_phone', 'contact_email', 'CreatedAt', 'cost', 'programming']
    return FilterDateByParams(filterColumnNames, obj)
  } else {
    const filterColumnNames = ['property_number', 'property_name', 'tsi_contact', 'product_1_desc', 'create_date']
    return FilterDateByParams(filterColumnNames, obj)
  }
}

export const FilterDateByParams = (params: any, obj: any) => {
  const newArray: any = [];
  let i: any = 0;
  for (i = 0; i < obj.length; i++) {
    const sortedArr: any = {};
    const Listings = obj[i];
    for (const propertyName in Listings) {
      if (params.indexOf(propertyName) !== -1) {
        // loop through properties
        if (propertyName === "due_date" || propertyName === "CreatedAt" || propertyName === "create_date") {
          if (Listings[propertyName]) {
            sortedArr[propertyName] = !Listings[propertyName] ? null : formatDate(Listings[propertyName]);
          } else {
            sortedArr[propertyName] = "";
          }
        } else if (propertyName === "cost") {
          if (Listings[propertyName]) {
            sortedArr[propertyName] = "$" + parseFloat(Listings[propertyName]).toFixed(2)
          }
          else {
            sortedArr[propertyName] = "";
          }
        }
        else {
          sortedArr[propertyName] = Listings[propertyName].trim().replace(/[\/\\]/g, '');
        }

      }
    }
    newArray.push(sortedArr)
  }
  return newArray;
}


// WEBPACK FOOTER //
// ./src/store/openModsReport/openModsReportFilter.ts